import { GrowAccountComponent } from './grow-account/grow-account.component';
import { GrowIntroComponent } from './grow-intro/grow-intro.component';
import { GrowProjectComponent } from './grow-project/grow-project.component';
import { GrowProjectDetailComponent } from './grow-project-detail/grow-project-detail.component';
import { GrowProjectsListComponent } from './grow-projects-list/grow-projects-list.component';
import { GrowRiskComponent } from './grow-risk/grow-risk.component';

export const components = [
  GrowAccountComponent,
  GrowProjectDetailComponent,
  GrowIntroComponent,
  GrowProjectsListComponent,
  GrowRiskComponent,
  GrowProjectComponent
];

export * from './grow-account/grow-account.component';
export * from './grow-intro/grow-intro.component';
export * from './grow-project/grow-project.component';
export * from './grow-project-detail/grow-project-detail.component';
export * from './grow-projects-list/grow-projects-list.component';
export * from './grow-risk/grow-risk.component';
